import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked", "name", "disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "n-radio__inner" }, null, -1)
const _hoisted_3 = { class: "n-radio__label label-m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass([
      'n-radio',
      {
        'n-radio_checked': _ctx.checked,
        'n-radio_disabled': _ctx.disabled,
        'n-radio_focused': _ctx.focused,
        'n-radio_hide-unchecked': _ctx.hideUnchecked
      }
    ])
  }, [
    _createElementVNode("input", {
      checked: _ctx.selectValue === _ctx.modelValue,
      type: "radio",
      name: _ctx.name,
      disabled: _ctx.disabled,
      class: "n-radio__input",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focused = true)),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focused = false))
    }, null, 40, _hoisted_1),
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ])
    ])
  ], 2))
}